import { createBrowserClient } from '@supabase/ssr';

// ÉN nettleserklient for hele appen — aldri én per kallsted.
//
// createClient() kalles 31 steder. Var den en fabrikk, fikk vi like mange
// GoTrueClient-instanser på samme lagringsnøkkel, og de slåss om den samme
// navigator-låsen (`lock:sb-<ref>-auth-token`). Målt i prod 28.8: låsen sto
// «held» uten noe «pending» — altså tatt og aldri sluppet. Da henger
// getSession() for alltid, useAuth() treffer 5-sekunders-timeouten sin, fanger
// feilen, setter user=null — og /coach viser innloggingsskjermen selv med
// gyldig sesjon. Coacher og admin måtte logge inn på nytt ved hver sidelast.
//
// Singleton fjerner konkurransen: én instans, én lås, ingen vranglås.
//
// ⚠️ Nettleserkode skal ALDRI lage sin egen klient med createClient fra
// @supabase/supabase-js. Den lagrer sesjonen i localStorage, mens sesjonen vår
// ligger i en cookie (@supabase/ssr). En slik klient finner ingenting, uten å
// gjøre ett eneste nettverkskall — så getSession() gir null og siden viser
// «Du må være innlogget» til en bruker som ER innlogget. Reprodusert 28.8 på
// /coach/billing og /coach/pakker.
let klient: ReturnType<typeof createBrowserClient> | null = null;

export function createClient() {
  if (klient) return klient;
  klient = createBrowserClient(
    process.env.NEXT_PUBLIC_SUPABASE_URL!,
    process.env.NEXT_PUBLIC_SUPABASE_ANON_KEY!
  );
  return klient;
}
